import { Appendix } from "../../../../../../shared/entities/scripts/appendix";
import { Study } from "../../../../../../shared/entities/scripts/study";
import { FormatDate, GetDateFromString } from "../../../../../../shared/scripts/date-functions";
import { FormatNumberWithCommas } from "../../../../../../shared/scripts/number-functions";
import { RenderDateMDY } from "../../../../../../shared/scripts/table-functions";
import { SiteInfo } from "../../../../sites/shared/sites.entities";
import { VisitLookup } from "../../visits-tab/scripts/visits.lookup";
import { SamplesEvent } from "./samples.entities";
import { SamplesLookup } from "./samples.lookup";

export class SamplesDialog {
    static table: any = undefined;

    static Initialize(showReasonNotDoneColumn: boolean) {
        SamplesDialog.table = $('#samples-details-modal #dialog-details-table').DataTable({
            autoWidth: true,
            info: false,
            paging: false,
            //pagingType: 'simple',
            //pageLength: 50,
            scrollX: true,
            scrollY: '70vh',
            searching: false,
            columns: [
                { data: "Study", title: "Platform", className: "text-left font-size12 nowrap" },
                { data: "Appendix", title: "Trial", className: "text-left font-size12 nowrap" },
                { data: "SiteNumber", title: "Site", className: "text-left font-size12 nowrap" },
                { data: { _: "VisitOrdering", display: "Visit", sort: "VisitOrdering" }, title: "Visit", className: "text-left font-size12 nowrap" },
                { data: "SampleName", title: "Biospecimen", className: "text-left font-size12 nowrap" },
                { data: "SampleStatus", title: "Status", className: "text-left font-size12 nowrap" },
                { data: "Subject", title: "Participant", className: "text-left font-size12 nowrap" },
                { data: "ReasonNotDone", title: "Reason Not Done", className: "text-left font-size12 nowrap" },
            ],
            buttons: [
                {
                    extend: 'csv',
                    className: "btn btn-secondary",
                    text: '<i class="fas fa-file-download"></i>',
                    charset: 'utf-8',
                    title: "RECOVER-CT Samples Details Export",
                    exportOptions: { columns: showReasonNotDoneColumn ? ':visible' : [0,1,2,3,4,5,6] }
                }
            ],
        });

        document.getElementById("export-samples-btn-dialog")?.addEventListener("click", () => {
            SamplesDialog.table.button('.buttons-csv').trigger();
        });
    }

    public static ShowDialog(samples: SamplesEvent[]): void {
        let showReasonNotDoneColumn: boolean = false;

        samples.sort((a, b) => {
            if (a.SubjectId < b.SubjectId) return -1;
            if (a.SubjectId > b.SubjectId) return 1;
            const aSample = SamplesLookup.GetSampleColumn(a.BiospecId) || "";
            const bSample = SamplesLookup.GetSampleColumn(b.BiospecId) || "";
            return aSample.localeCompare(bSample, undefined, { sensitivity: 'base' });
        });

        let tableRows: SamplesDialogRow[] = samples.map((v: SamplesEvent) => {
            if (!showReasonNotDoneColumn && v.SamplesStatusId == 4) { showReasonNotDoneColumn = true; }
            return new SamplesDialogRow(v);
        });       

        if (SamplesDialog.table == undefined) { SamplesDialog.Initialize(showReasonNotDoneColumn); }
        
        SamplesDialog.table.clear();
        SamplesDialog.table.rows.add(tableRows).draw();

        SamplesDialog.table.column(7).visible(showReasonNotDoneColumn);

        $('#samples-details-modal').modal('show');

        $('#samples-details-modal').on('shown.bs.modal', () => {
            SamplesDialog.table.columns.adjust();
            $('#samples-details-modal .dataTables_scrollBody').scrollTop(0);
            $('#samples-details-modal #modal-title').text("Number of Samples = " + FormatNumberWithCommas(samples.length + ""));
            //$('#visits-details-modal-count').text(visits.length);
        });

        $('#samples-details-modal').modal('show');
       
    }
}

export class SamplesDialogRow {
    Study: string;
    Appendix: string;
    SiteNumber: string;
    Subject: string;
    Visit: string;
    VisitOrdering: number;
    SampleName: string;
    SampleOrdering: number;
    SampleStatus: string;
    ReasonNotDone: string;

    constructor(event: SamplesEvent) {
        this.Study = Study.GetStudyName(event.StudyId);
        this.Appendix = Appendix.GetAppendixName(event.AppendixId);
        this.SiteNumber = SiteInfo.FormatSiteNumber(event.SiteNumber);
        this.Subject = event.SubjectId;
        this.Visit = VisitLookup.GetVisitMasterColumn(event.VisitAbb);
        this.VisitOrdering = VisitLookup.GetVisitMasterOrdering(event.VisitAbb);
        this.SampleName = SamplesLookup.GetSampleColumn(event.BiospecId);
        this.SampleOrdering = SamplesLookup.GetSampleOrdering(event.BiospecId);
        this.SampleStatus = SamplesLookup.GetSamplesSatusColumn(event.SamplesStatusId);
        //console.log("ReasonNotDoneId: ", event.ReasonNotDoneId);
        this.ReasonNotDone = SamplesLookup.GetReasonNotDoneColumn(event.ReasonNotDoneId);
        //console.log("Mapped ReasonNotDone: ", this.ReasonNotDone);
    }
}